import EventBus from 'eventing-bus';
import { useSelector, useDispatch } from 'react-redux';
import React, { useState, useEffect, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap';

import './AgencyPlansModal.css';
import '../../pages/Settings/index.css';
import FeedbackModal from '../FeedbackModal';
import PricingPlans from '../../pages/Settings/billing/PricingPlans';
import PlanAnimation from '../Animations/PlanAnimation.js';
import { getPlans, getCurrentPlan, createCheckoutSession } from '../../store/Payment';
import { switchWorkspace } from '../../store/Settings/index';

const AgencyPlansModal = ({ isOpen, toggle }) => {
  const feedbackButtonRef = useRef(null);
  const dispatch = useDispatch();
  const { currentWorkspace, workspaces } = useSelector(state => state['Settings'] || {});
  const { loading } = useSelector(state => state['Payment'] || {});

  // Check if grace period has expired
  const subscription = currentWorkspace?.['currentSubscription'];
  const lockReason = subscription?.['lockReason'];
  const gracePeriodEndsAt = subscription?.['gracePeriodEndsAt'];
  const isGracePeriodExpired = gracePeriodEndsAt && new Date(gracePeriodEndsAt) < new Date();

  const isPaymentRequired = lockReason === 'payment_required';
  const isGracePeriodEnded = lockReason === 'payment_failed' && isGracePeriodExpired;

  // Get other workspaces for switching option
  const otherWorkspaces = workspaces?.filter(ws => ws['_id'] !== currentWorkspace?.['_id']) || [];
  const hasOtherWorkspaces = otherWorkspaces.length > 0;
  const handleSwitchWorkspace = (workspaceId) => dispatch(switchWorkspace(workspaceId));

  useEffect(() => {
    if (isOpen) {
      dispatch(getPlans());
      dispatch(getCurrentPlan());
    }
  }, [isOpen])

  const handlePlanSelect = (data) => {
    dispatch(createCheckoutSession({
      data: { ...data, workspaceId: currentWorkspace['_id'] },
      successCallback: (responseBody) => data?.successCallback(),
      errorCallback: () => data?.errorCallback()
    }));
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        keyboard={false}
        backdrop="static"
        size={isGracePeriodEnded ? 'xl' : 'lg'}
        toggle={isGracePeriodEnded ? undefined : toggle}
        className={`agency-plans-modal ${isGracePeriodEnded ? 'grace-period-ended modal-fullscreen' : ''}`}
      >
        <ModalHeader toggle={isGracePeriodEnded ? undefined : toggle}>
          <div style={isGracePeriodEnded ? { textAlign: 'center', width: '100%' } : {}}>
            {isGracePeriodEnded ? (
              <>
                <h3 style={{ color: '#dc3545', marginTop: '20px', fontSize: '20px', fontWeight: '700' }}>
                  <i className="fa fa-exclamation-triangle" style={{ marginRight: '10px' }}></i>
                  Your Grace Period Has Ended
                </h3>
                <p style={{ fontSize: '14px', color: '#4a5568', margin: '0' }}>Your subscription payment has failed and the grace period has expired. Please update your billing information to continue using the service.</p>
              </>
            ) : (
              <>
                <h3>Choose Your Plan</h3>
                <p>Complete payment to activate your workspace: <strong>{currentWorkspace?.name}</strong></p>
              </>
            )}
          </div>
        </ModalHeader>

        <ModalBody>
          {loading ? (
            <div className="plans-loader-container"><PlanAnimation /></div>
          ) : (
            <>
              <div className="bottom-content-area">
                <div className="tabs-content">
                  <div className="plans-bill-area">
                    <PricingPlans
                      onSelectPlan={handlePlanSelect}
                      showBackButton={false}
                    />
                  </div>
                </div>
              </div>

              {/* <div className="payment-info-box">
                <i className="fa fa-info-circle"></i>
                <span>You will be redirected to our secure payment processor (Stripe) to complete the payment. After successful payment, your workspace will be automatically activated.</span>
              </div> */}

              {hasOtherWorkspaces && (
                <div className="workspace-switcher-section">
                  <div className="workspace-switcher-divider">
                    <span>Or switch to another workspace</span>
                  </div>
                  <div className="workspace-list">
                    {otherWorkspaces.map((workspace) => (
                      <button
                        key={workspace['_id']}
                        className="workspace-switch-btn"
                        onClick={() => handleSwitchWorkspace(workspace['_id'])}
                      >
                        <i className="fa fa-building"></i>
                        <span>{workspace['name']}</span>
                        <i className="fa fa-arrow-right"></i>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </ModalBody>
      </Modal>
      <div style={{ display: 'none' }}>
        <div ref={feedbackButtonRef}><FeedbackModal /></div>
      </div>
    </>
  )
}

export default AgencyPlansModal